<div #personalInfo id="personalinfo" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2 bg-white">
    <div class="flex flex-col sm:w-auto md:hidden">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Personal Information</h2>
            <p *ngIf="AddAdditionalApplicantKey == null">Please complete each field below.</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName == null">Please complete each
              field below for the additional applicant.</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName != null">Please complete each
              field below for {{AddAdditionalApplicantName}}.</p>
            <div *ngIf="errorMessage!=null" class="alert alert-danger">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>
      <form id="personalForm" #personalForm="ngForm" class="flex flex-col pt-8">
        <div>
          <div class="md:flex">
            <mat-form-field class="w-full md:w-1/3 my-2">
              <mat-label>Birth Month</mat-label>
              <mat-select name="birthMonth" id="birthMonth" required [(ngModel)]="model.birthMonth">
                <mat-option *ngFor="let month of months" [value]="month.value">
                  {{month.label}}
                </mat-option>
              </mat-select>
              <mat-error>Please fill out this field</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full my-2 md:w-1/3 md:px-2">
              <mat-label>Birth Day</mat-label>
              <mat-select name="birthDay" id="birthDay" required [(ngModel)]="model.birthDay">
                <mat-option *ngFor="let day of days" [value]="day.value">
                  {{day.label}}
                </mat-option>
              </mat-select>
              <mat-error>Please fill out this field</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full md:w-1/3 my-2">
              <mat-label>Birth Year</mat-label>
              <mat-select name="birthYear" id="birthYear" required [(ngModel)]="model.birthYear">
                <mat-option *ngFor="let year of years" [value]="year.value">
                  {{year.label}}
                </mat-option>
              </mat-select>
              <mat-error>Please fill out this field</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>SSN</mat-label>
              <input *ngIf="!showSSN" matInput prefix="XXX-XX-" mask="0000" name="SSN" id="SSN" required
                [(ngModel)]="maskedSSN" (focus)="unmaskSSN()">
              <input matInput *ngIf="showSSN" mask="000-00-0000" name="SSN" id="SSN" required [(ngModel)]="model.SSN"
                #SSN="ngModel" (blur)="maskSSN()" [cdkTrapFocusAutoCapture]="showSSN" [cdkTrapFocus]="showSSN"
                [showMaskTyped]="true">
              <mat-error>Please fill out this field. E.g. ###-##-####</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Drivers License</mat-label>
              <input matInput name="DLNum" id="DLNum" required [(ngModel)]="model.DLNum" #DLNum="ngModel">
              <mat-error>Please fill out this field</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>State</mat-label>
              <mat-select name="DLState" id="DLState" required [(ngModel)]="model.DLState" #DLState="ngModel">
                <mat-option *ngFor="let state of states" [value]="state.value">
                  {{state.label}}
                </mat-option>
              </mat-select>
              <mat-error>Please fill out this field</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Marital Status</mat-label>
              <mat-select name="RentalMaritalStatusKey" id="RentalMaritalStatusKey" required
                [(ngModel)]="model.RentalMaritalStatusKey" #RentalMaritalStatusKey="ngModel">
                <mat-option *ngFor="let maritalStatus of maritalStatuses" [value]="maritalStatus.value">
                  {{maritalStatus.label}}
                </mat-option>
              </mat-select>
              <mat-error>Please fill out this field</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Occupants Under 18</mat-label>
              <mat-select name="hasChildren" id="hasChildren" required [(ngModel)]="model.hasChildren"
                (onChange)="forceAtLeastOneOccupant()" #hasChildren="ngModel" [disabled]="disableOccupantDropDown()">
                <mat-option *ngFor="let hasChildrenOption of hasChildrenOptions" [value]="hasChildrenOption.value">
                  {{hasChildrenOption.label}}
                </mat-option>
              </mat-select>
              <mat-error>Please fill out this field</mat-error>
            </mat-form-field>
          </div>
          <div id="children" class="md:pl-4">
            <div *ngFor="let occupant of occupants; let i = index; trackBy:listTrack">
              <div class="md:flex md:items-center" *ngIf="model.hasChildren">
                <div>
                  <mat-form-field class="w-full my-2">
                    <mat-label>Name</mat-label>
                    <input matInput name="Name[{{i}}]" id="Name[{{i}}]" required [(ngModel)]="occupant.Name"
                      [disabled]="occupant.IsDisabled"  #OccupantName="ngModel">
                    <mat-error>Please fill out this field</mat-error>
                  </mat-form-field>
                </div>
                <div class="md:px-2">
                  <mat-form-field class="w-full my-2">
                    <mat-label>Year Born</mat-label>
                    <mat-select name="BirthYear[{{i}}]" id="BirthYear[{{i}}]" required [(ngModel)]="occupant.BirthYear" [disabled]="occupant.IsDisabled">
                      <mat-option *ngFor="let occupantBirthYear of occupantBirthYears"
                       [value]="occupantBirthYear.value">
                        {{occupantBirthYear.label}}
                      </mat-option>
                    </mat-select>
                    <mat-error>Please fill out this field</mat-error>
                  </mat-form-field>
                </div>
                <div>
                  <button mat-button color="accent" *ngIf="occupants.length > 1 && !occupant.IsDisabled"
                    (click)="onRemoveOccupantClick(occupant)" style="color: #545859">REMOVE</button>
                </div>
              </div>
            </div>
            <div *ngIf="model.hasChildren">
              <button mat-button color="accent" (click)="onAddOccupantClick()" style="color: #545859">ADD ADDITIONAL
                UNDER 18 OCCUPANT</button>
            </div>
          </div>
          <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Pet(s)</mat-label>
              <mat-select [matTooltip]="getPetFeeToolTip()" matTooltipPosition="left" name="hasPets" id="hasPets"
                required [(ngModel)]="model.hasPets" (selectionChange)="forceAtLeastOnePet()" #hasPets="ngModel" [disabled]="disablePetDropDown()">
                <mat-option *ngFor="let hasPetOption of hasPetOptions" [value]="hasPetOption.value">
                  {{hasPetOption.label}}
                </mat-option>
              </mat-select>
              <mat-error>Please fill out this field</mat-error>
            </mat-form-field>
          </div>
          <div id="pets" class="md:pl-4">
            <div *ngFor="let pet of pets; let i = index; trackBy:listTrack">
              <div *ngIf="model.hasPets">
                <div class="md:flex md:items-center">
                  <div class="md:px-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Pet Type</mat-label>
                      <mat-select name="RentalPetTypesKey[{{i}}]" id="RentalPetTypesKey[{{i}}]" required
                        [(ngModel)]="pet.RentalPetTypesKey"
                        [disabled]="pet.IsDisabled">
                        <mat-option *ngFor="let petType of petTypes" [value]="petType.value">
                          {{petType.label}}
                        </mat-option>
                      </mat-select>
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="md:px-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Breed</mat-label>
                      <input matInput name="Breed[{{i}}]" id="Breed[{{i}}]" required [(ngModel)]="pet.Breed"
                        [disabled]="pet.IsDisabled"
                        #Breed="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="md:px-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Name</mat-label>
                      <input matInput name="PetName[{{i}}]" id="PetName[{{i}}]" required [(ngModel)]="pet.PetName"
                        [disabled]="pet.IsDisabled"
                        #PetName="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="md:flex md:items-center">
                  <div class="md:px-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Color</mat-label>
                      <input matInput name="Color[{{i}}]" id="Color[{{i}}]" required [(ngModel)]="pet.Color"
                        [disabled]="pet.IsDisabled"
                        #Color="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="md:px-2">
                    <mat-form-field class="w-full my-2">
                      <mat-label>Weight</mat-label>
                      <input matInput name="Weight[{{i}}]" id="Weight[{{i}}]" required [(ngModel)]="pet.Weight"
                        [disabled]="pet.IsDisabled"
                        #Weight="ngModel">
                      <mat-error>Please fill out this field</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="md:px-2">
                    <mat-checkbox matInput name="IsServiceAnimal[{{i}}]" id="IsServiceAnimal[{{i}}]"
                      [disabled]="pet.IsDisabled"
                      [(ngModel)]="pet.IsServiceAnimal" #IsServiceAnimal="ngModel">Service Animal?</mat-checkbox>
                  </div>
                </div>
                <div>
                  <button mat-button color="accent" *ngIf="pets.length > 1 && !pet.IsDisabled" (click)="onRemovePetClick(pet)"
                    style="color: #545859">REMOVE</button>
                </div>
              </div>
            </div>
            <div *ngIf="model.hasPets">
              <button mat-button color="accent" (click)="onAddPetClick()" style="color: #545859">ADD ADDITIONAL
                PET</button>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button mat-flat-button color="primary" class="h-10 px-6" (click)="cancelEdit()"
            *ngIf="AddAdditionalApplicantKey != null">CANCEL EDIT</button>
          <button mat-flat-button color="primary" class="h-10 px-6 ml-2" (click)="removeUnusedOccupantsAndPets()"
            [disabled]="!personalForm.form.valid || disableSubmitBtn">CONTINUE</button>
        </div>
      </form>
    </div>
  </div>
</div>
